import index from '../components/index';
import store from '@/store'
import { ToastProgrammatic as Toast } from 'buefy'

export default [
    {
        path: '/tasks',
        component: index,
        name: 'tasks',
        meta: { auth: true },
        beforeEnter:(to,from,next)=>{
            let roles = store.state.auth.roles
            if(roles.includes('developer') || roles.includes('superadmin')){
                return next();
            }else{
                Toast.open({
                    type:'is-danger',
                    message:`You have no access to: ${to.path}`
                })
                store.commit('SET_LOADING',false)
                return next({
                    name:'tickets'
                })
            }
        }
    },
];